import { render, staticRenderFns } from "./YagiChatBot.vue?vue&type=template&id=139b7e32&scoped=true"
import script from "./YagiChatBot.vue?vue&type=script&setup=true&lang=ts"
export * from "./YagiChatBot.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./YagiChatBot.vue?vue&type=style&index=0&id=139b7e32&prod&lang=scss&scoped=true"
import style1 from "./YagiChatBot.vue?vue&type=style&index=1&id=139b7e32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139b7e32",
  null
  
)

export default component.exports